var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { Card } from '@philips-internal/oswald-ui-components';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { expression, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import './top-card.css';
import TopCardApi from './top-card-api';
let TopCard = class TopCard extends Component {
    constructor() {
        super(...arguments);
        this.open = () => {
            const { more } = this.props;
            if (more === 'resolution-time') {
                applicationContext.redirect(more);
            }
            else {
                applicationContext.openModule(more);
            }
        };
    }
    static { this.propTypes = {
        title: expression,
        value: string,
        more: string,
        seeMoreButtonText: expression,
    }; }
    render() {
        const { title, value, seeMoreButtonText } = this.props;
        return (React.createElement(Card, { className: "c-top-card", selectionType: SelectionType.NONE, transparent: true, uuid: generateUUID(), width: 3 },
            React.createElement("div", { className: "c-top-card__wrapper" },
                React.createElement("div", { className: "c-top-card__content" },
                    React.createElement("span", { className: "c-top-card__title" }, MessageService.translate(title)),
                    React.createElement("span", { className: "c-top-card__value" }, value),
                    React.createElement("div", { className: "c-top-card__bottom" },
                        React.createElement("span", { className: "c-top-card__see-more", onClick: () => this.open() }, MessageService.translate(seeMoreButtonText)))))));
    }
};
TopCard = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: TopCardApi })
], TopCard);
export default TopCard;
//# sourceMappingURL=top-card.js.map